export default {
    buttons: {
        save: 'Save',
    },
    fields: {
        password: {
            label: 'Password',
            placeholder: '6 characters minimum',
        },
        password_repeat: {
            label: 'Password Repeat',
            placeholder: 'Type your password again',
        },
    },
    passwords_not_match: 'Passwords do not match',
}
